import { useAuthStep } from "@/hooks/useAuthStep";
import { trackEvent } from "@/lib/utils";
import { useCommunication } from "@/lib/CommunicationWrapper";


const NoAccount = () => {

    const { setAuthStep, uuid } = useAuthStep();

    const { closeModal, updateOptions } = useCommunication();

    const skipAccount = () => {

        updateOptions({ auth_state: "skipped" });
        closeModal();
        trackEvent("signup_no_account", { "distinct_id": uuid });
    }

    return (
        <div className="px-[30px]">
            <h1 className="text-2xl font-semibold mb-[5px]">Trust us - you'll want a free account</h1>
            <p className="text-gray-500">You'll be missing out on all the good stuff</p>

            <div className="flex flex-col gap-[20px] mt-[30px]">
                <div>
                    <h3 className="font-medium text-black"><span className="mr-[5px]">❌</span> Unlimited themes</h3>
                    <p className="text-gray-500 text-sm ml-6">Swap your vibe as often as you want</p>
                </div>
                <div>
                    <h3 className="font-medium text-black"><span className="mr-[5px]">❌</span> Canvas Wrapped</h3>
                    <p className="text-gray-500 text-sm ml-6">See your top stats and compare with others at the end of the term.</p>
                </div>
                <div>
                    <h3 className="font-medium text-black"><span className="mr-[5px]">❌</span> Widget access</h3>
                    <p className="text-gray-500 text-sm ml-6">Access to widgets like music player, focus, breathe, and more...</p>
                </div>
            </div>

            <div className="flex flex-col gap-2 mt-[30px]">
                <button onClick={() => setAuthStep("logins")} className="font-medium bg-black text-white rounded-full px-[20px] py-[10px] flex-1 hover:brightness-95 transition-all duration-200" style={{ "background": "linear-gradient(120deg, var(--brand-1), var(--brand-2))" }}>Create <span className="font-bold">free</span> account</button>
                <button onClick={skipAccount} className="font-medium bg-white text-black rounded-full px-[20px] py-[10px] border border-gray-200 flex-1 hover:brightness-95 transition-all duration-200">No thanks</button>
            </div>
        </div>

    )
}

export default NoAccount;   